import { giphyBlack, giphyWhite } from '@giphy/colors'
import styled from 'styled-components'
import { BORDER_RADIUS_SMALL } from '../../../../constants'
import SuperCutStatus from '../../../../types/super-cut-status'

const Button = styled.div`
    vertical-align: middle;
    border-radius: ${BORDER_RADIUS_SMALL}px;
    align-items: center;
    background: ${giphyBlack};
    color: ${giphyWhite};
    font-size: 15px;
    line-height: 34px;
    text-align: center;
    box-sizing: border-box;
    display: inline-flex;
    flex-shrink: 0;
    justify-content: center;
    width: 120px;

    span {
        font-weight: bold;
        font-size: 15px;
        padding: 0 5px;
    }

    svg {
        display: block;
        height: 16px;
    }

    i {
        height: 12px;
        line-height: 1;
        transition: transform 0.2s ease-out;
    }
`

type Props = {
    status: SuperCutStatus
}
const StatusBox = ({ status }: Props) => {
    const IconComponent = SuperCutStatus.icon(status)
    return (
        <Button>
            <IconComponent />
            <span>{SuperCutStatus.title(status)}</span>
        </Button>
    )
}

export default StatusBox
